enum TunnelStatus {
  STABLE = 'stable',
  DISCONNECTED = 'disconnected',
  STANDBY = 'standby',
  UNKNOWN = '',
}

export default TunnelStatus;
